import React, { useEffect, useState } from 'react'
import { Container, Card, CardHeader, CardBody , Row, Button } from "react-bootstrap";
import PageTitle from '../components/common/PageTitle';
import { useTranslation } from 'react-i18next';
import { Link , useNavigate , useParams } from 'react-router-dom';
import api from '../api/api';
import swal from 'sweetalert';
import Pagination from '../views/Pagination';
import moment from 'moment';
import 'moment/locale/fr';
import 'moment/locale/ar';
import './ConfigurationManagement.css';

const ConfigCitiesWeather = () => {

    const params = useParams()
    let Id = params.id
    const navigate = useNavigate()
    const { t, i18n } = useTranslation();
const [daysNames, setDaysNames] = useState([]);
const [Months,setMonths] = useState([])
    



    // const Months = moment.monthsShort()
    const [weatherTemp, setWeatherTemp] = useState({})
    const [weatherHumd, setWeatherHumd] = useState({})
    const [rainData, setRainData] = useState({})
    const [ET0, setET0Data] = useState({})

    const [weatherTempDay, setWeatherTempDay] = useState({})
    const [weatherHumdDay, setWeatherHumdDay] = useState({})
    const [rainDataDay, setRainDataDay] = useState({})
    const [ET0DataDay, setET0DataDay] = useState({})

    const [selectMonth,setSelectMonth ] = useState('')
    const [allWeatherDataDays,setAllWeatherDataDays] = useState([])
    const [allWeatherData,setAllWeatherData] = useState([])
    useEffect(() => {
  moment.locale(i18n.language); // définit la langue pour moment
   setMonths(moment.monthsShort());        // mois courts traduits
  setDaysNames(moment.weekdaysShort());
}, [i18n.language]);

    const addCitiesWeather = () => {
        let data = {
            city_id : Id,
            weather_data : allWeatherData,
            weather_data_days : allWeatherDataDays
        }

        api.post('/admin/add-citiesWeather',data)
        .then(response=>{
            if(response && response.data.type === "success"){
                swal(`${t('City_Weather_Added')}`, { icon: "success" });
            }
            if(response && response.data.type === "danger"){
                swal(`${t('Error_Adding_City')}`, { icon: "error" });
            }
        }).catch(error=>{
            console.error(error)
        })
    }

    const onChangeHandlerRain = (value,month,name) => {
        setRainData(state => ({ ...state, [`${month}_${name}`] : value }), [])

    }
    const onChangeHandlerTempMoy = (value,month,name) => {
        setWeatherTemp(state => ({ ...state, [`${month}_${name}`] : value}), [])

    }
    const onChangeHandlerHumidity = (value,month,name) => {
        setWeatherHumd(state => ({ ...state, [`${month}_${name}`] : value }), [])

    }
    const onChangeHandlerET0 = (value,month,name) => {
        setET0Data(state => ({ ...state, [`${month}_${name}`] : value }), [])

    }


    const onChangeHandlerDayRain = (value,day,month,name) => {
        setRainDataDay(state => ({ ...state, [`${month}_${day}_${name}`] : value }), [])

    }
    const onChangeHandlerDayTempMoy = (value,day,month,name) => {
        setWeatherTempDay(state => ({ ...state, [`${month}_${day}_${name}`] : value}), [])

    }
    const onChangeHandlerDayHumidity = (value,day,month,name) => {
        setWeatherHumdDay(state => ({ ...state, [`${month}_${day}_${name}`] : value }), [])

    }
    const onChangeHandlerDayET0 = (value,day,month,name) => {
        setET0DataDay(state => ({ ...state, [`${month}_${day}_${name}`] : value }), [])

    }
    
    useEffect(()=>{
        let dataArray = []
        if ((Object.keys(rainData).length == 12)){
            dataArray.push(weatherTemp,weatherHumd,rainData,ET0)
            setAllWeatherData(dataArray)
        }
    },[rainData,ET0])

    useEffect(()=>{
        let dataArray = []
        if ((Object.keys(rainDataDay).length >= 28) || (Object.keys(weatherTempDay).length >= 28) || (Object.keys(weatherHumdDay).length >= 28) || (Object.keys(ET0DataDay).length >= 28) ){
            dataArray.push(weatherTempDay,weatherHumdDay,rainDataDay,ET0DataDay)
            setAllWeatherDataDays(dataArray)
        }
    },[rainDataDay,ET0DataDay])

    const weatherByMonths = () => {
            let element = []
        for (let index = 0; index < Months.length; index++) {
                element.push(
                    <tbody key={`month-${index}`}>
                    <tr>
                        <td>{Months[index]}</td>
                        <td>
                            <input
                             name={'temp'}
                             style={{ minHeight: 32, marginRight: 5, outline: 'none', border: "1px solid var(--sf-night-border, #e4e4e4)" }}
                             value={weatherTemp[`${index}_temp`] ?? ''}
                             onChange={e => onChangeHandlerTempMoy(e.target.value,index,'temp')}
                            />
                        </td>
                        <td>
                            <input
                             name={'humidity'}
                             style={{ minHeight: 32, marginRight: 5, outline: 'none', border: "1px solid var(--sf-night-border, #e4e4e4)" }}
                             value={weatherHumd[`${index}_humidity`] ?? ''}
                             onChange={e => onChangeHandlerHumidity(e.target.value,index,'humidity')}
                            />
                        </td>
                        <td>
                            <input
                             name={'rain'}
                             style={{ minHeight: 32, marginRight: 5, outline: 'none', border: "1px solid var(--sf-night-border, #e4e4e4)" }}
                             value={rainData[`${index}_rain`] ?? ''}
                             onChange={(e) => onChangeHandlerRain(e.target.value,index,'rain')}
                            />
                        </td>
                        <td>
                            <input
                             name={'et0'}
                             style={{ minHeight: 32, marginRight: 5, outline: 'none', border: "1px solid var(--sf-night-border, #e4e4e4)" }}
                             value={ET0[`${index}_et0`] ?? ''}
                             onChange={(e) => onChangeHandlerET0(e.target.value,index,'et0')}
                            />
                        </td>
                        {
                            selectMonth === ""
                            ?
                            <td><Button variant='outline-info'  onClick={() => {setSelectMonth(index)}} >{t('All_days')}</Button></td>

                            :
                            null
                        }
                 </tr>



                 </tbody>

                )

        }
        return element
    }

    const getDaysArray = (year, month) => {
        let monthIndex = month;
        const daysNames = moment.weekdaysShort(true);
        let date = new Date(year, monthIndex, 1);
        let result = [];
        while (date.getMonth() == monthIndex) {
            let daysIndex = date.getDate()
            result.push(
          <tbody key={`day-${daysIndex}`}>
          <tr>
              <td>{`${date.getDate()} ${daysNames[date.getDay()]}`}</td>
              <td>
                  <input
                   name={'temp'}
                   style={{ minHeight: 32, marginRight: 5, outline: 'none', border: "1px solid var(--sf-night-border, #e4e4e4)" }}
                   value={weatherTempDay[`${monthIndex}_${daysIndex}_temp`] ?? ''}
                   onChange={e => onChangeHandlerDayTempMoy(e.target.value,daysIndex,monthIndex,'temp')}
                  />
              </td>
              <td>
                  <input
                   name={'humidity'}
                   style={{ minHeight: 32, marginRight: 5, outline: 'none', border: "1px solid var(--sf-night-border, #e4e4e4)" }}
                   value={weatherHumdDay[`${monthIndex}_${daysIndex}_humidity`] ?? ''}
                   onChange={e => onChangeHandlerDayHumidity(e.target.value,daysIndex,monthIndex,'humidity')}
                  />
              </td>
              <td>
                  <input
                   name={'rain'}
                   style={{ minHeight: 32, marginRight: 5, outline: 'none', border: "1px solid var(--sf-night-border, #e4e4e4)" }}
                   value={rainDataDay[`${monthIndex}_${daysIndex}_rain`] ?? ''}
                   onChange={(e) => onChangeHandlerDayRain(e.target.value,daysIndex,monthIndex,'rain')}
                  />
              </td>
              <td>
                  <input
                   name={'et0'}
                   style={{ minHeight: 32, marginRight: 5, outline: 'none', border: "1px solid var(--sf-night-border, #e4e4e4)" }}
                   value={ET0DataDay[`${monthIndex}_${daysIndex}_et0`] ?? ''}
                   onChange={(e) => onChangeHandlerDayET0(e.target.value,daysIndex,monthIndex,'et0')}
                  />
              </td>
       </tr>



       </tbody>

          );
          date.setDate(date.getDate() + 1);
        }
        return result;
      }


  return (
         <Container className="management-page admin-management-page configuration-management-page p-4">
            <Link to='/admin/configuration/cities'> {t("Go_Back")}</Link>
             <Row noGutters className="page-header py-4">
                <PageTitle
                    sm="4"
                    title={t('Weather_Data_Info')}
                    subtitle={t('Weather_Data_Info')}
                    className="text-sm-left"
                />
            </Row>
                <Row className='p-2 text-center d-flex justify-content-center'>
                        <Card>
                            {
                                selectMonth === ""
                                ?
                                null
                                :
                            <CardHeader>
                                <h5>{t('month')} : {Months.at(selectMonth)}</h5>
                           <Button variant='outline-info' onClick={() => setSelectMonth("")}>
    {t('All_Months')}
</Button>

                            </CardHeader>

                            }
                            <CardBody>
                                <table className="table mb-0 border text-center  table-responsive">
                                    <thead className="bg-light">
                                        <tr>
                                           <th scope="col" className="border-0">
  {selectMonth === '' ? t('Months') : t('Days')}
</th>

                                            <th scope="col" className="border-0">{t('Temp Moy')} (°C)</th>
                                            <th scope="col" className="border-0">{t('Humidity Moy')} (%)</th>
                                            <th scope="col" className="border-0">{t('Rain Moy')} (mm)</th>
                                            <th scope="col" className="border-0">{t('ET0')} (mm)</th>
                                            
                                            {
                                             selectMonth === ''
                                             ?
                                            <th scope="col" className="border-0">{t('All_days')}</th>
                                                    :
                                                    null
                                                }
                                        </tr>
                                    </thead>
                                        {
                                             selectMonth === ''
                                             ?
                                        weatherByMonths()
                                             :
                                             getDaysArray(2022,selectMonth)
                                        }       
                                        
                                </table>                                        

                            </CardBody>
                        </Card>

                 </Row>
                <Row  className='p-2 text-center d-flex justify-content-center align-items-center'>
                    <div
                        style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap:"10px"
                        }}
                        >
                        <Button onClick={()  => addCitiesWeather()} className="mb-1 mr-1 btn btn-success"><i className="fa fa-check mx-2"></i>
                            {t('save')}
                        </Button>
                        <Button className="mb-1 mr-1 btn btn-danger" onClick={() => navigate('/admin/configuration/cities')}> <i className="fa fa-times mx-2"></i>
                            {t('cancel')}
                        </Button>
                    </div>
                 </Row>
         </Container>   
  )
}

export default ConfigCitiesWeather
